
import React, { useState } from 'react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import DataSourcesHeader from './DataSourcesHeader';
import DatabasesList from './DatabasesList';
import ETLPipelines from './ETLPipelines';
import DataIngestion from './DataIngestion';

interface DataSourcesSettingsProps {
  editing: boolean;
  onEditToggle: () => void;
  onSave: () => void;
}

const DataSourcesSettings: React.FC<DataSourcesSettingsProps> = ({ 
  editing, 
  onEditToggle, 
  onSave 
}) => {
  const [activeTab, setActiveTab] = useState('databases');

  return (
    <Card>
      <CardHeader className="pb-2">
        <DataSourcesHeader
          editing={editing}
          onEditToggle={onEditToggle}
          onSave={onSave}
        />
      </CardHeader>
      <CardContent className="space-y-6">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
          <TabsList className="grid grid-cols-3 sm:w-auto w-full">
            <TabsTrigger value="databases">Databases</TabsTrigger>
            <TabsTrigger value="etl">ETL Pipelines</TabsTrigger>
            <TabsTrigger value="ingestion">Data Ingestion</TabsTrigger>
          </TabsList>
          
          <TabsContent value="databases" className="space-y-6">
            <DatabasesList editing={editing} />
          </TabsContent>
          
          <TabsContent value="etl" className="space-y-6">
            <ETLPipelines editing={editing} />
          </TabsContent>
          
          <TabsContent value="ingestion" className="space-y-6">
            <DataIngestion editing={editing} />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default DataSourcesSettings;
